import { TransactionItemDetailEditProvider } from '@/features/transaction_items/Detail/context/TransactionItemDetailEdit';
import { TransactionItemDetail } from '@/features/transaction_items/Detail/TransactionItemDetail';

const TransactionItemDetailPage = () => {
  return (
    <TransactionItemDetailEditProvider>
      <TransactionItemDetail />
    </TransactionItemDetailEditProvider>
  );
};

export default TransactionItemDetailPage;
